module.exports = __webpack_public_path__ + "img/fcmy_s.0d8cb211.png";